import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const ImageDisplay = styled.div`
    justify-content: center;
    width: 100%;
    height: 240px;
    
    img {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: 150px;
        margin: 0 auto;
    }
`;

export const ImageItem = styled.div<{ isSelected: boolean }>`
    justify-content: center;
    width: 54px;
    height: 54px;
    border-radius: ${BorderRadius.labelRadius};
    overflow: hidden;
    cursor: pointer;
    ${({ isSelected }) => isSelected ? `border: 2px solid ${COLORS.ButtonAccent};` : ''}

    img {
        height: 100%;
    }
`;

